import styled from 'styled-components';
import { StyledInline } from '../../Inline/styled';

export const StyledListCell = styled.div`
  display: table-cell;
  width: ${(p) => (p.isExtended ? '100%' : '1px')};
  padding: ${(p) => !p.hasLink && `${p.theme.space[2]} ${p.theme.space[3]}`};
  white-space: ${(p) => (p.isExtended ? 'normal' : 'nowrap')};
  font-weight: inherit;
  text-align: left;
  vertical-align: middle;

  svg {
    vertical-align: bottom;
  }
`;

export const StyledListCellButton = styled(StyledListCell).attrs({
  as: 'button',
})`
  display: flex;
  width: 100%;
  color: ${(p) => p.isActive && p.theme.alias.primary};
  text-align: left;
  background-color: transparent;

  &:hover {
    background-color: ${(p) => p.theme.alias.shadow};
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusInner};
  }

  ${StyledInline} {
    margin-right: ${(p) => p.theme.space[1]};
  }

  svg path {
    stroke: currentColor;
  }
`;
